import Vue from 'vue';

let app;

const initAppointment = function () {
    app = new Vue({
        el: '#app',
        data: { info: {}, userFuncs: {} },
        methods: {
            executeDynamic() {
                let name = arguments[0];
                let args = Array.prototype.slice.call(arguments).slice(1);
                if (this.userFuncs[name]) {
                    this.userFuncs[name](args);
                } else {
                    console.warn(`${name} undefined`);
                }
            }
        }
    });
    Vue.set(app.userFuncs, 'centroClick', (params) => {
        centroClick(params[0]);
    });
    Vue.set(app.userFuncs, 'categoriaClick', (params) => {
        categoriaClick(params[0]);
    });
    Vue.set(app.userFuncs, 'subcategoriaClick', (params) => {
        subcategoriaClick(params[0]);
    });
    Vue.set(app.userFuncs, 'mostrarSubcategoriasClick', (params) => {
        mostrarSubcategoriasClick();
    });
    Vue.set(app.userFuncs, 'mostrarCentrosClick', (params) => {
        mostrarCentrosClick();
    });
    Vue.set(app.userFuncs, 'citaClick', (params) => {
        citaClick(params[0], params[1]);
    });
    Vue.set(app.userFuncs, 'mostrarCitasClick', (params) => {
        mostrarCitasClick();
    });

    /*
    
    
   if (!app.$options.updated) {
    app.$options.updated = [];
}
   app.$options.updated.push(() => {
    //init();
    console.log('updated');
});
*/
    cargarCentros();
    cargarCategorias();
    
}

const cargarCentros = function() {
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'GET',
        url: '/api/public/centros',
        data: null,
        dataType: 'json',
        success: function (data, status, jqXHR) {
            if (status == 'success' && data.status == 'OK') {
                Vue.set(app.info, 'centros', data.data);
            } else {
                console.log('error');
            }
        },
        error: function (jqXHR, status) {
            console.log('error');
        }
    });
};

const cargarCategorias = function() {
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'GET',
        url: '/api/public/categorias',
        data: null,
        dataType: 'json',
        success: function (data, status, jqXHR) {
            if (status == 'success' && data.status == 'OK') {
                Vue.set(app.info, 'categorias', data.data);
                if (data.data.length > 0) {
                    cargarSubcategorias(data.data[0]);
                    Vue.set(app.info, 'categoriaSeleccionada', data.data[0]);
                }
            } else {
                console.log('error');
            }
        },
        error: function (jqXHR, status) {
            console.log('error');
        }
    });
};

const cargarSubcategorias = function(categoria) {
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'GET',
        url: `/api/public/subcategorias/${categoria.id}`,
        data: null,
        dataType: 'json',
        success: function (data, status, jqXHR) {
            if (status == 'success' && data.status == 'OK') {
                categoria.subcategorias = data.data;
            } else {
                console.log('error');
            }
            Vue.set(app.info, 'categoriaSeleccionada', categoria);
            cargarCitas();
        },
        error: function (jqXHR, status) {
            console.log('error');
            Vue.set(app.info, 'categoriaSeleccionada', categoria);
            cargarCitas();
        }
    });
};

const cargarCitas = function() {
    Vue.set(app.info, 'citaSeleccionada', null);
    let idCentro;
    let idCategoria;
    if (!app.info.centroSeleccionado) {
        Vue.set(app.info, 'citas', null);
        return;
    }
    idCentro = app.info.centroSeleccionado.id;
    if (!app.info.categoriaSeleccionada) {
        Vue.set(app.info, 'citas', null);
        return;
    }
    if (app.info.categoriaSeleccionada.subcategorias.length > 0 && !app.info.subcategoriaSeleccionada) {
        Vue.set(app.info, 'citas', null);
        return;
    }
    if (app.info.subcategoriaSeleccionada) {
        idCategoria = app.info.subcategoriaSeleccionada.id;
    } else {
        idCategoria = app.info.categoriaSeleccionada.id;
    }
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'GET',
        url: `/api/public/citas/${idCentro}/${idCategoria}`,
        data: null,
        dataType: 'json',
        success: function (data, status, jqXHR) {
            if (status == 'success' && data.status == 'OK') {
                Vue.set(app.info, 'citas', data.data);
            } else {
                console.log('error');
                Vue.set(app.info, 'citas', null);
            }
        },
        error: function (jqXHR, status) {
            console.log('error');
            Vue.set(app.info, 'citas', null);
        }
    });
};

const centroClick = function(centro) {
    Vue.set(app.info, 'centroSeleccionado', centro);
    Vue.set(app.info, 'ocultarCentros', true);
    cargarCitas();
};

const categoriaClick = function(categoria) {
    Vue.set(app.info, 'subcategoriaSeleccionada', null);
    Vue.set(app.info, 'ocultarSubcategorias', false);
    if (!categoria.subcategorias) {
        cargarSubcategorias(categoria);
    } else {
        Vue.set(app.info, 'categoriaSeleccionada', categoria);
        cargarCitas();
    }
};

const subcategoriaClick = function(subcategoria) {
    Vue.set(app.info, 'subcategoriaSeleccionada', subcategoria);
    Vue.set(app.info, 'ocultarSubcategorias', true);
    cargarCitas();
};

const mostrarSubcategoriasClick = function() {
    Vue.set(app.info, 'subcategoriaSeleccionada', null);
    Vue.set(app.info, 'ocultarSubcategorias', false);
    cargarCitas();
};

const mostrarCentrosClick = function() {
    Vue.set(app.info, 'centroSeleccionado', null);
    Vue.set(app.info, 'ocultarCentros', false);
    cargarCitas();
};

const citaClick = function(cita, hora) {
    const citaSeleccionada = {
        cita: cita,
        hora: hora
    };
    Vue.set(app.info, 'citaSeleccionada', citaSeleccionada);
};

const mostrarCitasClick = function() {
    Vue.set(app.info, 'citaSeleccionada', null);
};

let formAppointmentValidator = null;
let lang;
const formAppointmentInitValidator = function() {
    if (formAppointmentValidator == null) {
        if ($('#form-appointment').length) {
            lang = 'EN';
        } else if ($('#form-appointment-es').length) {
            lang = 'ES';
        }
        if ('EN' == lang) {
            formAppointmentValidator = $('#form-appointment').validate({
                rules: {
                    appointment_name: {
                        required: true
                    },
                    appointment_lastname: {
                        required: true
                    },
                    appointment_email: {
                        required: true,
                        email: true
                    },
                    appointment_phone: {
                        required: true
                    },
                    appointment_partner: {
                        required: true
                    },
                    appointment_accept: {
                        required: true
                    }
                },
                messages: {
                    appointment_name: {
                        required: 'Write your name, please'
                    },
                    appointment_lastname: {
                        required: 'Write your last name, please'
                    },
                    appointment_email: {
                        required: 'Write your email, please',
                        email: 'The email is not correct'
                    },
                    appointment_phone: {
                        required: 'Write your phone number, please'
                    },
                    appointment_partner: {
                        required: 'Write your partner number, please'
                    },
                    appointment_accept: {
                        required: 'It is necessary to read and accept the legal notice'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formAppointmentValidator = $('#form-appointment-es').validate({
                rules: {
                    appointment_name: {
                        required: true
                    },
                    appointment_lastname: {
                        required: true
                    },
                    appointment_email: {
                        required: true,
                        email: true
                    },
                    appointment_phone: {
                        required: true
                    },
                    appointment_partner: {
                        required: true
                    },
                    appointment_accept: {
                        required: true
                    }
                },
                messages: {
                    appointment_name: {
                        required: 'Escriba su nombre, por favor'
                    },
                    appointment_lastname: {
                        required: 'Escriba sus apellidos, por favor'
                    },
                    appointment_email: {
                        required: 'Escriba su email, por favor',
                        email: 'El email no es correcto'
                    },
                    appointment_phone: {
                        required: 'Escriba su teléfono, por favor'
                    },
                    appointment_partner: {
                        required: 'Escriba su número de socio, por favor'
                    },
                    appointment_accept: {
                        required: 'Es necesario leer y aceptar el aviso legal'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
};

const formAppointmentSend = function() {
    $('#appointment-success').addClass('d-none');
    $('#appointment-error').addClass('d-none');
    formAppointmentInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-appointment').valid()) {
            return false;
        }
        url = '/api/formulario/appointment';
    } else if ('ES' == lang) {
        if (!$('#form-appointment-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/appointment';
    }
    $('#btn-appointment-send').addClass('d-none');
    $('#btn-appointment-sending').removeClass('d-none');
    const payload = {
        cita: app.info.citaSeleccionada.hora.id,
        name: $('#appointment_name').val(),
        surname: $('#appointment_lastname').val(),
        email: $('#appointment_email').val(),
        phone: $('#appointment_phone').val(),
        partner: $('#appointment_partner').val()
    };
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'POST',
        url: url,
        data: JSON.stringify(payload),
        dataType: 'json',
        success: function (data, status, jqXHR) {
            $('#btn-appointment-send').removeClass('d-none');
            $('#btn-appointment-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#appointment_name,#appointment_lastname,#appointment_email,#appointment_phone,#appointment_partner').val('');
                Vue.set(app.info, 'r_name', payload.name);
                Vue.set(app.info, 'r_lastname', payload.surname);
                Vue.set(app.info, 'r_phone', payload.phone);
                Vue.set(app.info, 'r_email', payload.email);
                Vue.set(app.info, 'r_partner', payload.partner);
                Vue.set(app.info, 'citaReservada', true);
            } else {
                $('#appointment-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-appointment-send').removeClass('d-none');
            $('#btn-appointment-sending').addClass('d-none');
            if ('EN' == lang)
                $('#appointment-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#appointment-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};
  
window.formAppointmentSend = formAppointmentSend;
window.initAppointment = initAppointment;
